import {
  DeviceStatus,
  DeviceTestResult,
} from "../results-view/ResultsView.types";
import { Devices, DeviceStatusDialogState } from "../../../types/Device.types";

export type DeviceStatusDialogBoxProps = {
  deviceName: Devices | undefined;
  isDialogOpen?: boolean;
  openDialog?: () => void;
  closeDialog?: () => void;
  isMobile: boolean;
  status: DeviceStatus | undefined;
  statusDetail: DeviceStatusDetail;
};

export type ConnectedDeviceStatusDialogBoxProps = {
  testResult: DeviceTestResult;
  deviceName: Devices;
};

export type DeviceStatusDetail = {
  header: string;
  body?: string;
};

// Map the Device Name to the Dialog name
export type IDeviceNameToDialogName = {
  [key in Devices]: DeviceStatusDialogState;
};

//Map the deviceName to Dialog state names
export const deviceToDialogName: IDeviceNameToDialogName = {
  [Devices.Network]: DeviceStatusDialogState.OPEN_NETWORK_DIALOG,
  [Devices.Camera]: DeviceStatusDialogState.OPEN_CAM_DIALOG,
  [Devices.Mic]: DeviceStatusDialogState.OPEN_MIC_DIALOG,
  [Devices.Speaker]: DeviceStatusDialogState.OPEN_SPEAKER_DIALOG,
};

// Interface to Map the Dialog state names to deviceName
export type IDialogNameToDeviceName = {
  [key in DeviceStatusDialogState]: Devices | undefined;
};

// Map the Dialog state names to deviceName
export const dialogStateToDeviceName: IDialogNameToDeviceName = {
  [DeviceStatusDialogState.OPEN_NETWORK_DIALOG]: Devices.Network,
  [DeviceStatusDialogState.OPEN_CAM_DIALOG]: Devices.Camera,
  [DeviceStatusDialogState.OPEN_MIC_DIALOG]: Devices.Mic,
  [DeviceStatusDialogState.OPEN_SPEAKER_DIALOG]: Devices.Speaker,
  [DeviceStatusDialogState.CLOSED]: undefined,
};
